import { memoize } from "lodash";
import type TrafficCountrySignalRowDto from "app/pages/sales-intelligence/sub-modules/signals/models/traffic/TrafficCountrySignalRowDto";
import { splitArrayByIndex } from "app/pages/sales-intelligence/utils/arrays";
import createTooltipColumnsResolver from "../../../../services/table-columns/traffic/new-markets/tooltipColumnsFactory";
import type SignalsTooltipViewModel from "../SignalsTooltipViewModel";
import type TooltipTableColumn from "../TooltipTableColumn";

type FactoryDeps = {
    metric: string;
    countries: TrafficCountrySignalRowDto[];
    itemsLimit: number;
};

export default function createTrafficSignalsTooltipViewModel({
    metric,
    countries,
    itemsLimit,
}: FactoryDeps): SignalsTooltipViewModel<TrafficCountrySignalRowDto, TooltipTableColumn> {
    const tableColumnsResolver = createTooltipColumnsResolver({ metric });

    const isItemLimitReached = countries.length > itemsLimit;

    const getSplitLists = (): [TrafficCountrySignalRowDto[], TrafficCountrySignalRowDto[]] => {
        return isItemLimitReached ? splitArrayByIndex(countries, itemsLimit) : [countries, []];
    };
    const getSplitListsMemoized = memoize(getSplitLists);

    return {
        get visibleItems(): TrafficCountrySignalRowDto[] {
            const [displayedTechnologies] = getSplitListsMemoized();

            return displayedTechnologies;
        },

        get otherItems(): TrafficCountrySignalRowDto[] {
            const [, remainingTechnologies] = getSplitListsMemoized();

            return remainingTechnologies;
        },

        getPresentationDetailList(): TooltipTableColumn[] {
            return tableColumnsResolver.getTableColumns();
        },
    };
}
